var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInnerChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.75C1.84229 1.75 1.75 1.87216 1.75 1.9697V15.228L2.97789 14.0373C3.11782 13.9016 3.30508 13.8258 3.5 13.8258H18C18.1577 13.8258 18.25 13.7036 18.25 13.6061V1.9697C18.25 1.87216 18.1577 1.75 18 1.75H2ZM0.25 1.9697C0.25 1.00056 1.05771 0.25 2 0.25H18C18.9423 0.25 19.75 1.00056 19.75 1.9697V13.6061C19.75 14.5752 18.9423 15.3258 18 15.3258H3.80392L1.52211 17.5384C1.30584 17.7481 0.985088 17.8081 0.707666 17.6907C0.430244 17.5733 0.25 17.3012 0.25 17V1.9697Z",
    fill: "#48A14D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 4.87891C5.25 4.46469 5.58579 4.12891 6 4.12891H14C14.4142 4.12891 14.75 4.46469 14.75 4.87891C14.75 5.29312 14.4142 5.62891 14 5.62891H6C5.58579 5.62891 5.25 5.29312 5.25 4.87891Z",
    fill: "#48A14D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 7.78809C5.25 7.37387 5.58579 7.03809 6 7.03809H14C14.4142 7.03809 14.75 7.37387 14.75 7.78809C14.75 8.2023 14.4142 8.53809 14 8.53809H6C5.58579 8.53809 5.25 8.2023 5.25 7.78809Z",
    fill: "#48A14D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 10.6968C5.25 10.2826 5.58579 9.94678 6 9.94678H10C10.4142 9.94678 10.75 10.2826 10.75 10.6968C10.75 11.111 10.4142 11.4468 10 11.4468H6C5.58579 11.4468 5.25 11.111 5.25 10.6968Z",
    fill: "#48A14D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerChatIcon);
export default __webpack_public_path__ + "static/media/innerChatIcon.5cac626b3b2eed5ed2fdd265cacacc3c.svg";
export { ForwardRef as ReactComponent };